import React, { useEffect, useState } from "react";

export const FastCounter = ({ speed = 20 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Generate a random target between 5000–10000 (excluding round thousands)
    let num;
    do {
      num = Math.floor(Math.random() * (10000 - 5000 + 1)) + 5000;
    } while (num % 1000 === 0);

    let current = 0;
    const step = Math.ceil(num / 50);

    const timer = setInterval(() => {
      current += step;
      if (current >= num) {
        current = num;
        clearInterval(timer);
      }
      setCount(current);
    }, speed);

    return () => clearInterval(timer);
  }, [speed]);

  return count;
};
